__turbopack_context__.v({
  "chip": "Chip-module-scss-module__X0NaDa__chip",
  "selected": "Chip-module-scss-module__X0NaDa__selected",
  "unselected": "Chip-module-scss-module__X0NaDa__unselected",
});
